/* models/textures/texture.js */ function _(require, module, exports) {
    const model_1 = require(64) /* ../../model */;
    const p = require(18) /* ../../core/properties */;
    class Texture extends model_1.Model {
        constructor(attrs) {
            super(attrs);
        }
        static init_Texture() {
            this.define({
                repetition: [p.TextureRepetition, "repeat"],
            });
        }
        onload(defer_func) {
            defer_func();
        }
    }
    exports.Texture = Texture;
    Texture.__name__ = "Texture";
    Texture.init_Texture();
}
